export const cols = [{
	prop: 'shopname',
	label: '店铺名称',
	width: '120',
	ischoose: false,
	align: 'center'
}, {
	prop: 'ordertype',
	label: '单据类型',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '单据编号',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'createdate',
	label: '下单时间',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'preparedate',
	label: '备货日期',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'wantarrivaldate',
	label: '到货日期',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerName',
	label: '客户名称',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerCode',
	label: '客户编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderstatus',
	label: '订单状态',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'itemquantity',
	label: '订货数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendcount',
	label: '实发数量',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'getcount',
	label: '实收数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffcount',
	label: '差发数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buydiffcount',
	label: '差收数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundquantity',
	label: '实退数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceivecount',
	label: '净收数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realmoney',
	label: '订货金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'needPayMoney',
	label: '应收款',
	width: '120',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'orderDiffMoney',
	label: '订单差异金额(含运费)',
	width: '130',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'oDiffMoneyExcludeFreight',
	label: '订单差异金额(不含运费)',
	width: '130',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendmoney',
	label: '实发金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getmoney',
	label: '实收金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffmoney',
	label: '差发金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buydiffmoney',
	label: '差收金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundmoney',
	label: '实退金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceiveMoney',
	label: '净收金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'itemWeight',
	label: '订货重量',
	width: '180',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendWeight',
	label: '发货重量',
	width: '180',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'receiveWeight',
	label: '收货重量',
	width: '180',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'offlinemoney',
	label: '线下支付金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'onlinemoney',
	label: '微信支付金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'tenpayMoney',
	label: '微企付支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'preMoney',
	label: '预付货款金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayonlineMoney',
	label: '云资金-网商余额支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayremittanceMoney',
	label: '云资金-汇付支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayCITICMoney',
	label: '云资金-中信支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
},
// {
// 	prop: 'cldpayFuYouAccMoney',
// 	label: '云资金-富友账户通支付金额',
// 	width: '180',
// 	ischoose: true,
// 	headerAlign: 'center',
// 	align: 'right'
// },
{
	prop: 'b2bwechatMoney',
	label: 'B2b门店助手-微信支付',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'b2bbankMoney',
	label: 'B2b门店助手-银行转账',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayCashierOnlineMoney',
	label: '云资金-网商收银台',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayLklSmbMoney',
	label: '拉卡拉全渠道-余额支付',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
// }, {
// 	prop: 'cldpayCashierLklSmbMoney',
// 	label: '拉卡拉全渠道-收银台',
// 	width: '180',
// 	ischoose: true,
// 	headerAlign: 'center',
// 	align: 'right'
}, {
	prop: 'cldpayLklBalanceMoney',
	label: '拉卡拉钱包余额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
},
{
	prop: 'buyername',
	label: '收货人',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buytel',
	label: '联系电话',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyeraddress',
	label: '收货地址',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'companycode',
	label: '物流公司',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'ffmnumber',
	label: '物流单号',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'linename',
	label: '线路',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'memo',
	label: '买家备注',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'systemmemo',
	label: '系统备注',
	width: '180',
	// ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sellermemo',
	label: '卖家备注',
	width: '180',
	// ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'relatenumber',
	label: '关联退单号',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'liquidateflag',
	label: '是否勾销',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'freight',
	label: '运费',
	width: '120',
	headerAlign: 'center',
	align: 'center'
}]
